import { HelpCircle } from "lucide-react";

/**
 * Tiny "?" icon that deep-links the staff Training Manual to a specific
 * module. Dispatches a `glpflo:open-training` window event with the
 * target sectionId; dashboards listen for this event and:
 *   1. Switch their activeTab to "training"
 *   2. Pass the sectionId via URL hash (#training:<id>) so the manual
 *      can auto-expand + scroll to that module.
 *
 * Use inline next to any UI surface that has dedicated training:
 *   <HelpLink sectionId="rx-commission-overrides" title="Help: how this card works" />
 *
 * Visual size is 14px to fit comfortably inline with card titles and
 * chip rows without dominating them.
 */
export default function HelpLink({ sectionId, title = "Open training module", className = "", size = 14 }) {
  if (!sectionId) return null;
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // The hash is read by StaffTrainingManual on mount + hashchange so
    // the right module auto-opens. The custom event tells the host
    // dashboard to switch to its training tab.
    try {
      window.location.hash = `#training:${sectionId}`;
    } catch {
      /* hash can fail in some sandboxes; fallback below */
    }
    window.dispatchEvent(new CustomEvent("glpflo:open-training", { detail: { sectionId } }));
  };
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      className={`inline-flex items-center justify-center text-slate-400 hover:text-purple-600 dark:hover:text-purple-300 transition-colors cursor-pointer ${className}`}
      data-testid={`help-link-${sectionId}`}
    >
      <HelpCircle style={{ width: size, height: size }} />
    </button>
  );
}
